import React, { useMemo } from 'react';
import { AppBar, Title } from 'react-admin';
import { Avatar, Box, Typography } from '@mui/material';
// import { LineChart, Line, ResponsiveContainer } from 'recharts';

// 简单示例数据，可以替换成从 API 拉取
// const sparkData = [
//   { x: 1, y: 10 },
//   { x: 2, y: 18 },
//   { x: 3, y: 12 },
//   { x: 4, y: 22 },
//   { x: 5, y: 16 },
// ];

const CustomAppBar = (props: any) => {
  // 获取用户名
  const userName = useMemo(() => {
    return localStorage.getItem('username') || 'Guest';
  }, []);

  const userInitial = useMemo(() => userName.trim().charAt(0).toUpperCase() || 'G', [userName]);

  return (
    <AppBar
      {...props}
      elevation={0}
      sx={{
        height: 64,
        justifyContent: 'center',
        px: { xs: 1.5, md: 2 },
        borderRadius: 0,
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e5e7eb',
        color: '#0f172a',
        '& .RaSidebarToggleButton-root, & button[aria-label="Open menu"], & button[aria-label="Close menu"]': {
          color: '#0f172a !important',
          backgroundColor: '#dbeafe !important',
          border: '1px solid #60a5fa',
          borderRadius: '8px',
          boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.18)',
        },
        '& .RaSidebarToggleButton-root:hover, & button[aria-label="Open menu"]:hover, & button[aria-label="Close menu"]:hover': {
          backgroundColor: '#bfdbfe !important',
          borderColor: '#3b82f6',
        },
        '& .RaSidebarToggleButton-root:focus-visible, & button[aria-label="Open menu"]:focus-visible, & button[aria-label="Close menu"]:focus-visible': {
          outline: '2px solid #2563eb',
          outlineOffset: '1px',
        },
        '& .RaSidebarToggleButton-root .MuiSvgIcon-root, & button[aria-label="Open menu"] .MuiSvgIcon-root, & button[aria-label="Close menu"] .MuiSvgIcon-root': {
          color: '#0f172a !important',
          opacity: 1,
          fontSize: '1.6rem',
          fontWeight: 700,
        },
        '& .RaSidebarToggleButton-menuButtonIcon, & .RaSidebarToggleButton-menuButtonIconOpen': {
          color: '#0f172a !important',
          fontSize: '1.6rem',
          opacity: 1,
        },
        '& .RaAppBar-title': {
          fontSize: '1.08rem',
          fontWeight: 700,
          color: '#0f172a',
        },
        '& button[aria-label="Refresh"], & .RaRefreshIconButton-root': {
          display: 'none',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: 0 }}>
        {/* 左侧：品牌区 */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minWidth: { xs: 170, md: 220 },
            width: { xs: 170, md: 220 },
            height: 40,
            px: 1.5,
            py: 0.5,
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            border: '1px solid #cbd5e1',
            boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: 4,
              height: 20,
              borderRadius: '999px',
              backgroundColor: '#1d4ed8',
              flexShrink: 0,
            }}
          />
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.8, minWidth: 0, ml: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: '1.12rem', md: '1.24rem' },
                fontWeight: 800,
                letterSpacing: '0.08em',
                lineHeight: 1,
                color: '#0f172a',
              }}
              noWrap
            >
              BODCO
            </Typography>
            <Typography
              sx={{
                fontSize: '0.62rem',
                fontWeight: 700,
                letterSpacing: '0.14em',
                color: '#64748b',
                lineHeight: 1,
                textTransform: 'uppercase',
                pt: '2px',
              }}
              noWrap
            >
              Industrial
            </Typography>
          </Box>
        </Box>

        {/* 中间：页面标题 */}
        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Title defaultTitle="Dashboard" />
        </Box>

        {/* 占位 */}
        <Box sx={{ flex: 1 }} />

        {/* 右侧：欢迎区 */}
        <Typography
          sx={{
            mr: 1,
            fontSize: '1rem',
            fontWeight: 600,
            color: '#1e3a8a',
            lineHeight: 1,
          }}
        >
          Welcome, {userName}
        </Typography>

        {/* <Avatar
          sx={{
            width: 32,
            height: 32,
            fontSize: '0.85rem',
            fontWeight: 700,
            bgcolor: '#1e293b',
            color: '#f8fafc',
          }}
        >
          {userInitial}
        </Avatar> */}
      </Box>
    </AppBar>
  );
};

export default CustomAppBar;